import pathToRegexp from '../path-to-regexp';
const cache = {};
const cacheLimit = 10000;
let cacheCount = 0;
function compilePath(path, options) {
  const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
  const pathCache = cache[cacheKey] || (cache[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  const keys = [];
  const regexp = pathToRegexp(path, keys, options);
  const result = {
    regexp,
    keys
  };
  if (cacheCount < cacheLimit) {
    pathCache[path] = result;
    cacheCount++;
  }
  return result;
}

/**
 * Public API for matching a URL pathname to a path.
 */
function matchPath(pathname, props) {
  if (typeof props === 'string' || Array.isArray(props)) {
    props = {
      path: props
    };
  }
  const {
    path,
    exact = false,
    strict = false,
    sensitive = false
  } = props;
  const paths = [].concat(path);
  return paths.reduce((matched, currentPath) => {
    if (!currentPath) return null;
    if (matched) return matched;
    const {
      regexp,
      keys
    } = compilePath(currentPath, {
      end: exact,
      strict,
      sensitive
    });
    const regexMatch = regexp.exec(pathname);
    if (!regexMatch) return null;
    const [url, ...values] = regexMatch;
    const isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: currentPath,
      // the path used to match
      url: currentPath === '/' && url === '' ? '/' : url,
      // the matched portion of the URL
      isExact,
      // whether or not we matched exactly
      params: keys.reduce((memo, key, index) => {
        // @ts-ignore indexing generic Params with string key
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}
export default matchPath;